import { ArrowLongLeftIcon, ArrowLongRightIcon } from '@heroicons/react/20/solid';
import * as _ from 'lodash-es';
import classNames from "../utils";
import {useWindowSize} from "../useWindowSize";

const 
Pagination = ({ links, fetchData }) => {
    const width = useWindowSize().width;

    const handlePageClick = (page) => {
        window.scrollTo(10, 10)
        fetchData(page);
    };


    return (
        _.has(links, 'links') &&
        links.last_page > 1 && (
            <nav
                className={classNames(
                    'flex items-center  py-10',
                    width ? 'justify-center' : 'justify-between'
                )}
            >
                {links.current_page === 1 ? (
                    <div className=""></div>
                ) : (
                    <ArrowButton link={links.links[0]} hide={links.current_page === 1} next={false} onClick={() => handlePageClick(links.current_page - 1)} />
                )}
                <div className="-mt-px">
                    {links.links.map((link, key) => {
                        if (key === 0 || links.links.length - 1 === key) {
                            return null;
                        }
                        return <Current key={key} link={link} onClick={() => handlePageClick(Number(link.label))} />;
                    })}
                </div>
                {links.current_page === links.last_page ? (
                    <div className=""></div>
                ) : (
                    <ArrowButton
                        link={links.links[links.links.length - 1]}
                        hide={links.current_page === links.last_page}
                        next={true}
                        onClick={() => handlePageClick(links.current_page + 1)}
                    />
                )}
            </nav>
        )
    );
};

export default Pagination;

const ArrowButton = ({ hide, next, onClick }) => {
    const width = useWindowSize().width;

    return (
        <>
            {!hide && width >= 500 ? (
                <div
                    onClick={onClick}
                    className="inline-flex items-center border-t-2 border-transparent pt-4 pr-1 text-sm font-medium text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                    {!next ? (
                        <div className="circle-border-left w-12 h-12 rounded-full border border-gray-200 flex justify-center items-center">
                            <ArrowLongLeftIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                    ) : (
                        <div className="circle-border w-12 h-12 rounded-full border-2 border-gray-200 flex justify-center items-center">
                            <ArrowLongRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                    )}
                </div>
            ) : (
                <div className="inline-flex items-center" />
            )}
        </>
    );
};

const Current = ({ link, onClick }) => {
    return (
        <>
            {link.url ? (
                <div
                    onClick={onClick}
                    className={classNames(
                        !link.active
                            ? 'inline-flex items-center sm:px-4 px-2 pt-4 text-sm font-medium text-darkBg dark:text-lightBg cursor-pointer'
                            : 'inline-flex items-center sm:px-4 px-2 pt-4 text-sm font-medium text-blue-500 dark:text-blue-500 cursor-pointer'
                    )}
                >
                    {link.label}
                </div>
            ) : (
                <div
                    className={classNames(
                        'inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-darkBg dark:text-lightBg'
                    )}
                >
                    {link.label}
                </div>
            )}
        </>
    );
};
